export var ELogisticsType;
(function (ELogisticsType) {
    ELogisticsType[ELogisticsType["Direct"] = 1] = "Direct";
    ELogisticsType[ELogisticsType["Straight"] = 2] = "Straight";
    ELogisticsType[ELogisticsType["Delivery"] = 3] = "Delivery";
    ELogisticsType[ELogisticsType["tempData"] = 4] = "tempData";
    ELogisticsType[ELogisticsType["VirtualStraight"] = 5] = "VirtualStraight";
})(ELogisticsType || (ELogisticsType = {}));
export default ELogisticsType;
